module.exports = __webpack_public_path__ + "static/media/results-page-validate-icon.9ebc0286.svg";